<template>
  <div class="item" :class="['item-type-' + type]">
    <div class="item-left" @click="bindClickImage">
      <img class="item-icon" :src="data.image" alt="" />
      <img class="item-brand" :src="data.brand_img" alt="" />
    </div>
    <div class="item-center">
      <div class="item-name" v-html="data.keywordTitle || data.p_title"></div>
      <div class="tag-list"
        ><span
          class="tag-item"
          v-for="(item, index) in data.efficacy"
          :key="index"
          >{{ item.title }}</span
        >
      </div>
      <div class="item-space"></div>
      <div class="item-b-content">
        <div class="item-num" v-if="type == 1"
          >{{ data.eat_count }}人正在吃</div
        >
        <div class="item-num" v-if="type == 2"
          >{{ data.usage[data.curSelect].every_times_num
          }}{{ data.min_unit_txt }}/次·{{
            data.usage[data.curSelect].daily_times
          }}次/日</div
        >
        <div class="item-btn">
          <div class="add-text" v-if="!data.select && data.is_plan">已添加</div>
          <div
            class="add-btn iconfont icon-jiahao"
            @click="bindClickAdd($event)"
            v-else-if="
              !data.select &&
              !data.is_plan &&
              data.usage &&
              data.usage.length == 1
            "
          ></div>
          <div
            class="select-btn"
            @click="bindClickSelect"
            v-else-if="
              !data.select &&
              !data.is_plan &&
              data.usage &&
              data.usage.length > 1
            "
            >选方案</div
          >
          <div
            class="plan-btn iconfont icon-jianhao"
            @click="bindClickDel"
            v-else-if="data.select"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //类型 1用于普通列表展示 2用于购物车展示
    type: {
      type: Number,
      default: 1
    },
    data: {
      type: Object,
      default: null
    }
  },
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClickImage() {
      this.$emit('detail', this.data)
    },
    bindClickAdd(event) {
      this.$emit('add', this.data, event)
    },
    bindClickSelect() {
      this.$emit('add', this.data)
    },
    bindClickDel() {
      this.$emit('del', this.data)
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  padding: 0px 16px 0px 10px;
  display: flex;
  align-items: flex-start;

  .item-left {
    position: relative;
    width: 90px;
    height: 90px;
    border-radius: 6px;
    margin-right: 13px;

    .item-icon {
      width: 100%;
      height: 100%;
      border-radius: 6px;
      overflow: hidden;
      object-fit: cover;
    }

    .item-brand {
      position: absolute;
      left: 0;
      top: 0;
      width: 45px;
      height: 15px;
      object-fit: cover;
      border-radius: 6px 0px 6px 0px;
    }
  }

  .item-center {
    min-height: 90px;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;

    .item-name {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 4px;
    }

    .item-space {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
    }

    .tag-list {
      display: flex;
      flex-wrap: wrap;

      .tag-item {
        white-space: nowrap;
        padding: 0px 3px;
        font-size: 9px;
        background: rgba(254, 248, 225, 1);
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        color: #fe8b1a;
        line-height: 14px;
        border-radius: 2px;
        margin-right: 8px;
        margin-bottom: 4px;
      }
    }

    .item-b-content {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .item-num {
        margin-top: 4px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 14px;
      }

      .item-btn {
        display: flex;
        align-items: center;
        justify-content: center;

        .add-text {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
        }

        .select-btn {
          font-size: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          text-align: center;
          width: 54px;
          height: 19px;
          line-height: 19px;
          background: #03d4e6;
          border-radius: 10px;
        }

        .add-btn {
          width: 19px;
          height: 19px;
          font-weight: bold;
          background: #03d4e6;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 12px;
        }

        .plan-btn {
          width: 19px;
          height: 19px;
          font-size: 14px;
          border-radius: 50%;
          border: 2px solid #03d4e6;
          box-sizing: border-box;
          color: rgba(3, 212, 230, 1);
          display: flex;
          font-weight: bold;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}

.item-type-2 {
  .item-left {
    width: 76px;
    height: 76px;
  }

  .item-center {
    min-height: 76px;
  }
}
</style>
